import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import { PieChart } from 'echarts/charts';
import * as echarts from 'echarts/core';
import { getColor } from 'helpers/utils';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import SimpleBarReact from 'simplebar-react';
import FalconCardHeader from 'components/common/FalconCardHeader';

import BasicECharts from 'components/common/BasicEChart';
import {
  GridComponent,
  TitleComponent,
  TooltipComponent
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
// import { color } from 'd3';

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  PieChart,
  CanvasRenderer
]);

const getOptions = (data, radius, total) => {
  const colors = data.map(item => getColor(item.color));
  return {
    color: colors,

    tooltip: {
      // padding: [7, 10],
      transitionDuration: 0,
      backgroundColor: getColor('gray-100'),
      borderColor: getColor('gray-300'),
      textStyle: {
        fontSize: 12,
        color: getColor('gray-1100')
      },
      borderWidth: 1,
      formatter: params =>
        `<strong>${params.data.name}:</strong> ${params.percent}%`
    },
    series: [
      {
        name: total,
        type: 'pie',
        radius,
        avoidLabelOverlap: false,
        // emphasis: {
        //     scale: false
        // },
        itemStyle: {
          borderWidth: 2,
          borderColor: getColor('gray-100')
        },
        label: {
          show: false
          //     position: 'center',
          //     formatter: '{a}',
          //     fontSize: 18,
          //     color: getColor('gray-1100')
        },
        emphasis: {
          label: {
            show: false // Garantir que a ênfase também não mostre o valor
          }
        },
        data
      }
    ]
  };
};

const TopModalidadeItem = ({ item, index }) => {
  const { name, color, value } = item;

  return (
    <Flex
      alignItems="center"
      justifyContent="between"
      className={`fw-semi-bold fs--2 ${index == 0 && 'mt-3'}`}
    >
      <p className="mb-1">
        <FontAwesomeIcon
          icon="circle"
          className={`me-2 text-${color.split('-')[1] || color}`}
        />
        {name} &nbsp;-&nbsp;{value}
      </p>
      {/* <div className="d-xxl-none">{percentage}</div> */}
    </Flex>
  );
};

const TopModalidade = ({ data, radius }) => {
  const colorOp = [];
  useEffect(() => {
    if (data.length > 0) {
      for (let index = 0; index < data.length; index++) {
        colorOp.push(getColor(data[index].color));
      }
    }
  }, []);

  return (
    <>
      <Card className="h-100 ">
        <FalconCardHeader title={'Embarques por Modal'} titleTag="h6" />
        <SimpleBarReact
          style={{ height: '18rem', overflowY: 'hidden' }}
          autoHide={false}
        >
          <Card.Body className="ps-2">
            {Array.isArray(data) && data.length > 0 ? (
              <Row className="justify-content-between g-0">
                <Col xs={4} sm={4} xxl className="pe-2">
                  {data.map((item, index) => (
                    <TopModalidadeItem item={item} index={index} key={index} />
                  ))}
                </Col>
                <Col xs={8} sm={8} xxl className="pe-2">
                  <div
                    style={{
                      transform: 'scale(0.8)',
                      transformOrigin: 'top center'
                    }}
                  >
                    <BasicECharts
                      echarts={echarts}
                      options={getOptions(data, radius)}
                    />
                  </div>
                </Col>
              </Row>
            ) : (
              <div className="text-center p-3">Sem embarques</div>
            )}
          </Card.Body>
        </SimpleBarReact>
      </Card>
    </>
  );
};

TopModalidadeItem.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired
  }),
  index: PropTypes.number.isRequired
};

TopModalidade.propTypes = {
  data: PropTypes.array.isRequired,
  radius: PropTypes.array.isRequired
};

export default TopModalidade;

// import React from 'react';
// import ReactECharts from 'echarts-for-react';
// import { Card, Col, Row } from 'react-bootstrap';
// import { getColor } from 'helpers/utils';
// import SimpleBarReact from 'simplebar-react';
// import FalconCardHeader from 'components/common/FalconCardHeader';

// const TopModalidade = ({ modalidades, values, valoresConvertidos }) => {
//     const getOption = () => {
//         return {
//             tooltip: {
//                 trigger: 'item',
//                 formatter: (params) => {
//                     return `${params.name}: ${params.value.toLocaleString()}`;
//                 },
//                 textStyle: {
//                     fontSize: 10, // Tamanho da fonte do tooltip
//                 },
//             },
//             xAxis: {

//                 type: 'category',
//                 data: modalidades, // Importadores no eixo Y
//                 axisLabel: {
//                     formatter: (value) => {
//                         return value.length > 60 ? value.substring(0, 60) + '...' : value; // Limitar a 60 caracteres
//                     },
//                     align: 'center', // Alinhar à esquerda
//                     textStyle: {
//                         fontSize: 10, // Tamanho da fonte do tooltip
//                     },
//                 },
//                 splitLine: {
//                     show: true, // Mostrar linhas de grade no eixo X
//                     lineStyle: {
//                         type: 'dashed', // Estilo da linha (opcional)
//                         color: '#ccc', // Cor da linha
//                     },
//                 },
//             },
//             yAxis: {
//                 type: 'value', // Eixo X com os valores
//                 axisLabel: {
//                     formatter: (value) => {
//                         return value.toLocaleString(); // Formatar como número com vírgulas
//                     },
//                 },
//                 splitLine: {
//                     show: true, // Mostrar linhas de grade no eixo Y
//                     lineStyle: {
//                         type: 'dashed', // Estilo da linha (opcional)
//                         color: '#ccc', // Cor da linha
//                     },
//                 },
//             },
//             series: [{
//                 name: 'Valor',
//                 type: 'bar',
//                 data: values,
//                 barWidth: '50%',
//                 itemStyle: {
//                     color: getColor('primary'),
//                 },
//                 label: {
//                     show: false, // Exibir rótulos
//                     //     position: 'insideRight', // Rótulos à direita das barras
//                     //     fontSize: 10,
//                     //     color: '#fff',
//                     //     rotate: 360,
//                 },
//                 emphasis: {
//                     label: {
//                         show: false, // Garantir que a ênfase também não mostre o valor
//                     },
//                 },
//             }],
//             grid: {
//                 left: '5%', // Margem esquerda de 20%
//                 right: '5%', // Margem direita
//                 top: '10%', // Margem superior
//                 bottom: '10%', // Margem inferior
//             },
//         }

//     };

//     return (
//         <Card className="h-100 ">
//             <FalconCardHeader title={"Embarques por Modal"} titleTag="h6" />
//             <SimpleBarReact style={{ height: '18rem' }}>
//                 <Card.Body className="ps-2">
//                     <div style={{ transform: 'scale(0.8)', transformOrigin: 'top center' }}>
//                         <ReactECharts option={getOption()} />
//                     </div>
//                 </Card.Body>
//             </SimpleBarReact>
//         </Card>
//     );
// };

// export default TopModalidade;
